<template>
  <form-section>
    <el-row :gutter="30">
      <el-col :span="12">
        <inbox-message-settings-form
          v-if="model.inbox_settings"
          type="web"
          v-model="model"
        ></inbox-message-settings-form>
      </el-col>

      <el-col :span="12">
        <div class="preview-frame">
          <web-inbox-preview
            v-if="model.inbox_settings"
            logo-url="/img/powered_by_XP.png"
            :push-notification-switch="model.inbox_settings.switch"
            :position="model.inbox_settings.position"
            :colors="model.inbox_settings.colors"
          />
        </div>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import WebInboxPreview from '@/modules/settings/components/WebInboxPreview'
import InboxMessageSettingsForm from '@/modules/settings/components/InboxMessageSettingsForm'
import FormSection from '@/common/components/form/FormSection'
import { inboxSettingsWeb } from '@/modules/settings/enum/WebInboxDefaultSettings'
export default {
  name: 'InboxMessageSettingsWeb',
  components: {
    FormSection,
    WebInboxPreview,
    InboxMessageSettingsForm
  },
  props: {
    model: {
      required: true
    }
  },
  mounted() {
    if (this.model.inbox_settings === null) {
      this.model.inbox_settings = { ...inboxSettingsWeb }
    }
    if (
      !this.model.inbox_settings.button ||
      !['default', 'custom'].includes(this.model.inbox_settings.button)
    ) {
      this.model.inbox_settings.button = 'default'
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.preview-frame {
  height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/InboxMessageSettingsWeb.vue